
<div>
  <div v-if="action.responseType === actionResponseType.Text">
    <div v-if="action.type === actionType.Get">{{ action.result }}</div>
    <div v-if="action.type === actionType.Post">{{ action.postResult }}</div>
  </div>

  <div v-if="action.responseType === actionResponseType.Html">
    <div v-if="action.type === actionType.Get" v-html="action.result"></div>
    <div v-if="action.type === actionType.Post" v-html="action.postResult"></div>
  </div>

  <div v-if="action.responseType === actionResponseType.Json">
    <pre>{{ prettyJson }}</pre>
  </div>

  <div v-if="action.responseType === actionResponseType.CrewContactInformation">
    <CrewContactInformation :data="jsonData"></CrewContactInformation>
  </div>

  <div v-if="action.responseType === actionResponseType.GroundOpsFlightInformation">
    <GroundOpsFlightInformation :data="jsonData"></GroundOpsFlightInformation>
  </div>

  <div v-if="action.responseType === actionResponseType.CommercialDelay">
    <BoardItemDelayInfo v-model="jsonData"></BoardItemDelayInfo>
  </div>
</div>
